import  OrbitingCirclesDemo  from "./OrbitingCirclesDemo";

const LoadingLayer = () => {
  return (
    <div className=' basic-data-table background-smog-forest'>
      <div className='card-body py-80 px-32 text-center'>
        <h6 className='mb-16 animation-text-1'>PAKISTAN PLANTATION & GROWTH MONITORING SYSTEM IS LOADING...</h6>
        <OrbitingCirclesDemo />
      </div>
    </div>
  );
};

export default LoadingLayer;
